export const polylineStyle = {
  fill: "none",
  stroke: "#004057",
  vectorEffect: "non-scaling-stroke",
  strokeWidth: 1,
  strokeLinecap: "round",
};
